package horcrux.frontend.common.views.components.input.selectors

import horcrux.common.utils.EnumCompanion
import horcrux.common.utils.StringEnum
import horcrux.frontend.common.views.components.containers.HStack
import horcrux.frontend.common.views.components.containers.VStack
import horcrux.frontend.common.views.components.input.InfoPopover
import mui.material.Button
import mui.material.ButtonVariant
import mui.material.Stack
import mui.material.StackDirection
import mui.system.PropsWithSx
import mui.system.responsive
import mui.system.sx
import react.ChildrenBuilder
import react.FC
import react.PropsWithChildren
import react.router.NavigateFunction
import react.router.useNavigate
import web.cssom.JustifyContent
import web.cssom.pt

external interface ButtonSelectorProp<Enum : StringEnum> : PropsWithSx {
    var id: String
    var currentSelection: Enum
    var onClick: (Enum, NavigateFunction) -> Unit
}

fun <Enum : StringEnum> EnumCompanion<Enum>.buttonSelector(
    helpTextMaybe: String? = null,
): FC<ButtonSelectorProp<Enum>> =
    FC { props ->
        VStack {
            HStack {
                this.sx {
                    this.justifyContent = JustifyContent.center
                    this.marginBottom = 10.pt
                    +props.sx
                }
                val navigate = useNavigate()
                for ((i, value) in this@buttonSelector.valuesList.withIndex()) {
                    Button {
                        +value.stringValue
                        this.id = "${props.id}-${value.stringValue}-select"
                        this.variant =
                            if (value == props.currentSelection) ButtonVariant.contained else ButtonVariant.outlined
                        this.onClick = { props.onClick(value, navigate) }
                        this.sx {
                            if (i == (this@buttonSelector.valuesList.size - 1) && helpTextMaybe != null) {
                                this.marginRight = 10.pt
                            }
                        }
                    }
                }

                helpTextMaybe?.let {
                    InfoPopover {
                        this.id = "${props.id}-help"
                        this.text = it
                    }
                }
            }
        }
    }
